import Tooltip from '../common/Tooltip'
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined'
import { useOutputGoal } from '../../hooks/useKpis'

/**
 * Formats a yyyy-mm-dd string as dd-mm-yyyy; passes anything else through.
 * @param {string} value
 * @returns {string}
 */
const formatDate = (value) => {
    if (typeof value !== 'string') return ''
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    return match ? `${match[3]}-${match[2]}-${match[1]}` : value
}

/**
 * Doel column cell on the AddOutputs table. Shows the target number + date, or
 * "Stel een doel in" when no goal is set.
 *
 * @param {object} props
 * @param {{ID: string}} props.output - Outputs doc
 * @param {(output: object) => void} props.onOpen - Opens the goal modal for this output
 */
const OutputGoalCell = ({ output, onOpen }) => {
    const { goal } = useOutputGoal(output?.ID || '')

    return (
        <div className='output-goal-cell'>
            <Tooltip content={'Doel instellen'} width='80%' top='-60px'>
                <TrackChangesOutlinedIcon
                    className='table-delete-icon'
                    onClick={() => onOpen(output)}
                />
            </Tooltip>
            {goal && goal.TargetValue !== undefined ? (
                <span className='output-goal-value' onClick={() => onOpen(output)}>
                    {goal.TargetValue}{goal.Deadline ? ` · ${formatDate(goal.Deadline)}` : ''}
                </span>
            ) : (
                <span className='output-goal-empty' onClick={() => onOpen(output)}>
                    Stel een doel in
                </span>
            )}
        </div>
    )
}

export default OutputGoalCell
